module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.isSms2faEnabled) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.sms2faEnabledWarning')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))])], 1) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.title')))]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('static.googleTwoFactorVerification.enableWarningMessage'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [(_vm.qrCodeImage) ? _c('img', {
    staticStyle: {
      "width": "120px",
      "margin": "auto"
    },
    attrs: {
      "alt": "Image of QR barcode",
      "src": _vm.qrCodeImage
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.codeVerification')))]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    staticClass: "margin-b-10",
    attrs: {
      "placeholder": _vm.$t('static.googleTwoFactorVerification.enterToken')
    },
    model: {
      value: (_vm.twoFactorAuthToken),
      callback: function($$v) {
        _vm.twoFactorAuthToken = $$v
      },
      expression: "twoFactorAuthToken"
    }
  }, [_c('el-button', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-check",
      "loading": _vm.verifyLoading
    },
    on: {
      "click": _vm.verifyToken
    },
    slot: "append"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.googleTwoFactorVerification.verifyCode')) + "\n                ")])], 1)], 1)])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd8fa6b","hasScoped":false}!./src/app/components/googleTwoFactorAuthSetup/googleTwoFactorAuthSetup.html
// module id = 2976
// module chunks = 1